export default {
    CERTIFICATION_STATUS: {
        0: '待提交',
        1: '待审核',
        2: '审核通过',
        3: '审核不通过'
    },
    APP_STATUS: {
        0: '待启用',
        1: '启用',
        2: '停用'
    },
    APP_SUPPORT_PLATFORM: {
        0: '爱库存app',
        1: '饷店H5'
    },
    MESSAGE_SUBSCRIPTION_STATUS: {
        0: '未订阅',
        1: '待测试',
        2: '订阅成功'
    },
    SETTLE_ORDER_TYPE: {
        0: '软件服务'
    },
    SETTLE_STATUS: {
        0: '待结算',
        1: '已结算'
    },
    SETTLE_CHECK_STATUS: {
        0: '待生成',
        1: '待确认',
        2: '已确认',
        3: '异议待处理'
    },
    SETTLE_INVOICE_STATUS: {
        0: '待开票',
        1: '已开票'
    },
    SETTLE_ORDER_STATUS: {
        10: '新建待支付',
        20: '已支付待发货',
        30: '已发货待收货',
        40: '已完成',
        50: '已取消'
    }
};
